import { ReduxStore } from 'store/types';

function getAllEmptyMessage(state: ReduxStore): string {
  return state.product.getAll.config.emptyMessage;
}

export default getAllEmptyMessage;
